import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/MainPage.vue'
import About from '@/components/About.vue'
import Work from '@/components/Work.vue'
import Project from '@/components/Project.vue'
import Menu from '@/components/Menu.vue'
import MenuColor from '@/components/MenuColor.vue'

Vue.use(Router)



export default new Router({
  mode:'history',


  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },








  routes:[
    {
      path:'/',
      name:'Home',
      components:{default: MainPage, menu : Menu},
      meta: {title: 'Nicolas Noel - Designer graphiste'}
    },
    {
      path:'/a-propos',
      name:'Apropos',
      components:{default:About, menu : Menu},
      meta: {title: 'Nicolas Noel - À propos'}
    },
    {
      path:'/projets',
            name:'Projets',
      components:{default:Work, menu : MenuColor},
      meta: {title: 'Nicolas Noel - Projets'}
    },
    {
      name:'projet',
      path: '/projet/:slug',
      components:{default:Project, menu : Menu},
      meta: {title: 'Nicolas Noel - Projets'}
    },
    {
      path:'*',
      redirect:'/'
    }

  ]
})
